export class InternalMessagingFilterModel {
  mailbox: string[] = ['00000271-1000-0000-0000-000000000001'];
  from: string[] = [];
  to: string[] = [];
  types: string[] = [];
  priorities: string[] = [];
  patientId: string;
}
